import { combineReducers } from "redux";

import { detailConstants } from "../actions/deadlines/detail";

import { notesConstants } from "../actions/detailsDocument/notes";

import { downloadConstants } from "../actions/download/index";
import { previewConstants } from "../actions/deadlines/preview";

function subjective(state, { type, payload, scope }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case notesConstants.CREATE_NOTE_SUCCESS:
    /** cerco dentro attachmentsDetail.documentId = a idAttachment */
    if (defaultState && defaultState.attachmentsDetail) {
      let foundAttachmentIndex = defaultState.attachmentsDetail.findIndex((el) => {
        return el.documentId === payload.documentID;
      });
      if (foundAttachmentIndex >= 0) {
        if (defaultState.attachmentsDetail[foundAttachmentIndex] && !defaultState.attachmentsDetail[foundAttachmentIndex].notes) {
          defaultState.attachmentsDetail[foundAttachmentIndex].notes = [];
        }
        defaultState.attachmentsDetail[foundAttachmentIndex].notes.push({
          id: payload.id,
          createdBy: payload.createdBy,
          createdOn: new Date(),
          updatedOn: payload.updatedOn,
          userName: payload.userName,
          noteText: payload.noteText,
          itemClassifier: payload.itemClassifier
        });
      }
    }
    return { ...defaultState };
  case notesConstants.DELETE_NOTE_SUCCESS:
    /**
       * /** cerco dentro attachmentsDetail.documentId = a idAttachment */
    if (defaultState && defaultState.idAttachment) {
      let foundAttachmentIndex = defaultState.attachmentsDetail.findIndex((el) => {
        return el.documentId === defaultState.idAttachment;
      });
      if (foundAttachmentIndex >= 0) {
        if (defaultState.attachmentsDetail[foundAttachmentIndex] && !defaultState.attachmentsDetail[foundAttachmentIndex].notes) {
          defaultState.attachmentsDetail[foundAttachmentIndex].notes = [];
        }
        let newDeadlinesNotes = defaultState.attachmentsDetail[foundAttachmentIndex].notes.filter((el) => {
          return el.id !== payload.noteID;
        });
        defaultState.attachmentsDetail[foundAttachmentIndex].notes = newDeadlinesNotes;
      }
    }
    return { ...defaultState };
  case notesConstants.MODIFY_NOTE_NEW_SUCCESS:
    if (defaultState && defaultState.idAttachment) {
      let foundAttachmentIndex = defaultState.attachmentsDetail.findIndex((el) => {
        return el.documentId === defaultState.idAttachment;
      });
      if (defaultState.attachmentsDetail[foundAttachmentIndex] && !defaultState.attachmentsDetail[foundAttachmentIndex].notes) {
        defaultState.attachmentsDetail[foundAttachmentIndex].notes = [];
      }
      if (foundAttachmentIndex >= 0) {
        let copyDeadlines = defaultState.attachmentsDetail[foundAttachmentIndex];
        let modifiedNote = copyDeadlines.notes.find((el) => {
          return el.id === payload.noteId;
        });
        modifiedNote.noteText = payload.noteText;
        modifiedNote.updatedOn = new Date();
        defaultState.attachmentsDetail[foundAttachmentIndex] = copyDeadlines;
        return {
          ...defaultState
        };
      }
    }
    return { ...defaultState };
  case detailConstants.GET_DEADLINES_DETAIL_SUCCESS:
    return payload;
  case detailConstants.GET_DEADLINES_DETAIL_START:
    return null;
  case previewConstants.GET_PREVIEW_DEADLINE_SUCCESS:
    return {
      ...defaultState,
      preview: payload.content,
      idAttachment: payload.idAttachment,
      fileName: payload.fileName
    };
  case detailConstants.UPDATE_ATTACHMENTS_DETAIL_SUCCESS:
    // ho bisogno delle info per recuperare le info dell'allegato
    return { ...defaultState, attachmentsDetail: payload };
  case detailConstants.SET_DEADLINES_REJECT_SUCCESS: {
    if (defaultState) {
      defaultState.status.rejected = true;
      defaultState.payment.step = "rejected";
    }
    return { ...defaultState };
  }
  case detailConstants.SET_DEADLINES_AUTHORIZE_SUCCESS: {
    if (defaultState) {
      defaultState.status.rejected = false;
      defaultState.status.authorized = true;
      defaultState.payment.step = "authorized";
    }
    return { ...defaultState };
  }
  case detailConstants.SET_DEADLINES_PAYMENT_SUCCESS: {
    if (defaultState && defaultState.payment.execution) {
      defaultState.payment.status = payload.paymentStatus;
      defaultState.payment.execution.mode = payload.paymentMode;
      defaultState.payment.execution.date = payload.paymentDate;
    }
    if (defaultState && !defaultState.payment.execution) {
      defaultState.payment.status = payload.paymentStatus;
    }
    if (payload.paymentStatus === "due" && defaultState.totalAmount < 0) {
      defaultState.payment.step = "to_be_paid";
    } else if (payload.paymentStatus === "due" && defaultState.totalAmount > 0) {
      defaultState.payment.step = "to_be_collected";
    } else {
      defaultState.payment.step = payload.paymentStatus;
    }
    return { ...defaultState };
  }
  case downloadConstants.DOCUMENT_DOWNLOAD_SUCCESS: {
    let updatedContentOriginal =
        defaultState && defaultState?.attachmentsDetail
          ? defaultState.attachmentsDetail.find((el) => {
            return el.documentId === payload.docId;
          })
          : [];
    updatedContentOriginal["contentOriginal"] = payload?.data?.content;
    return { ...defaultState };
  }
  case previewConstants.GET_PREVIEW_DEADLINE_START: {
    return { ...defaultState, preview: null };
  }
  default:
    return defaultState;
  }
}

function isLoadingModified(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.MODIFIED_DEADLINES_START:
  case detailConstants.SPLIT_DEADLINES_START:
    return true;
  case detailConstants.MODIFIED_DEADLINES_SUCCESS:
  case detailConstants.GET_DEADLINES_DETAIL_START:
  case detailConstants.MODIFIED_DEADLINES_ERROR:
  case detailConstants.SPLIT_DEADLINES_SUCCESS:
  case detailConstants.SPLIT_DEADLINES_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isLoadingPreview(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case previewConstants.GET_PREVIEW_DEADLINE_START:
    return true;
  case previewConstants.GET_PREVIEW_DEADLINE_SUCCESS:
  case previewConstants.GET_PREVIEW_DEADLINE_ERROR:
  case detailConstants.GET_DEADLINES_DETAIL_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isGettingDeadlines(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.GET_DEADLINES_DETAIL_START:
    return true;
  case detailConstants.GET_DEADLINES_DETAIL_SUCCESS:
  case detailConstants.GET_DEADLINES_DETAIL_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isModifiedDedline(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.MODIFIED_DEADLINES_SUCCESS:
  case detailConstants.SPLIT_DEADLINES_SUCCESS:
    return true;
  case detailConstants.GET_DEADLINES_DETAIL_START:
  case detailConstants.MODIFIED_DEADLINES_START:
  case detailConstants.MODIFIED_DEADLINES_ERROR:
  case detailConstants.SPLIT_DEADLINES_START:
  case detailConstants.SPLIT_DEADLINES_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function dailyTotals(state, { type, payload }) {
  const NULL_STATE = { toPay: 0, toCollect: 0 };
  let defaultState = typeof state === "undefined" ? NULL_STATE : state;
  switch (type) {
  case detailConstants.GET_DEADLINES_DETAIL_START:
  case detailConstants.GET_DEADLINES_DETAIL_ERROR:
  case detailConstants.GET_DEADLINES_DAILYTOTALS_START:
  case detailConstants.GET_DEADLINES_DAILYTOTALS_ERROR:
    return NULL_STATE;
  case detailConstants.GET_DEADLINES_DAILYTOTALS_SUCCESS:
    return payload;
  default:
    return defaultState;
  }
}

function isErrorGettingStatistics(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.GET_DEADLINES_DETAIL_ERROR:
    return error || {};
  case detailConstants.GET_DEADLINES_DETAIL_START:
  case detailConstants.GET_DEADLINES_DETAIL_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function isPayingDeadline(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.SET_DEADLINES_PAYMENT_START:
    return true;
  case detailConstants.SET_DEADLINES_PAYMENT_SUCCESS:
  case detailConstants.SET_DEADLINES_PAYMENT_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function recurrency(state, { type, payload }) {
  let defaultS =
    typeof state === "undefined"
      ? {
        listDeadlines: [],
        error: false
      }
      : state;
  switch (type) {
  case detailConstants.GET_RECURENCY_START:
    return {
      listDeadlines: [],
      error: false
    };
  case detailConstants.GET_RECURRENCY_SUCCESS:
    return {
      listDeadlines: payload.recurrency._embedded.deadlines,
      error: false
    };
  case detailConstants.GET_RECURRENCY_ERROR:
    return {
      listDeadlines: [],
      error: true
    };
  default:
    return defaultS;
  }
}

function splittedDeadlines(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined"
      ? {
        error: false,
        isSplitting: false
      }
      : state;
  switch (type) {
  case detailConstants.SPLIT_DEADLINES_START:
    return {
      error: false,
      isSplitting: true
    };
  case detailConstants.SPLIT_DEADLINES_SUCCESS:
    return {
      error: false,
      isSplitting: false
    };
  case detailConstants.SPLIT_DEADLINES_ERROR:
    return {
      error: true,
      isSplitting: false
    };
  default:
    return defaultState;
  }
}

export const deadlinesDetail = combineReducers({
  subjective,
  isGettingDeadlines,
  isErrorGettingStatistics,
  isLoadingModified,
  isLoadingPreview,
  isModifiedDedline,
  isPayingDeadline,
  dailyTotals,
  recurrency,
  splittedDeadlines
});

export default deadlinesDetail;
